import { ReactNode } from 'react';
import { Button, type ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface LoadingButtonProps extends ButtonProps {
  loading?: boolean;
  children: ReactNode;
  loadingText?: string;
  showSpinner?: boolean;
  spinnerSize?: 'sm' | 'md' | 'lg';
}

const spinnerSizes = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
};

export function LoadingButton({
  loading = false,
  children,
  loadingText,
  showSpinner = true,
  spinnerSize = 'md',
  disabled,
  className,
  ...props
}: LoadingButtonProps) {
  const isDisabled = disabled || loading;

  return (
    <Button
      {...props}
      disabled={isDisabled}
      className={cn(className)}
    >
      {loading ? (
        <div className="flex items-center justify-center gap-2">
          {showSpinner && (
            <div
              className={cn(
                'animate-spin rounded-full border-2 border-current border-t-transparent',
                spinnerSizes[spinnerSize]
              )}
            />
          )}
          <span>{loadingText || children}</span>
        </div>
      ) : (
        children
      )}
    </Button>
  );
}

LoadingButton.displayName = 'LoadingButton';
